import React from 'react';

import _ from 'lodash';
import checkOverflow from "../utils/checkModalOverflow";

class DeclineModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            declinedCandidateName: '',
            candidateDeclined: false,
            checkboxValue: false,
            message: ''
        };
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.isVisible !== nextProps.isVisible) {
            checkOverflow(nextProps.isVisible);
        }
    }

    render() {
        let classes = "modal-overlay decline-modal-overlay";
        if (this.props.isVisible) classes += " active";

        return (
            <div onClick={this.toggleModal.bind(this)} className={classes}>
                <div onClick={this.modalClick.bind(this)} className="modal whitebox">
                    <header className="modal-header">
                        <h1>Decline hired candidate</h1>
                        <button className="close" onClick={this.toggleModal.bind(this)}><span>&times;</span></button>
                    </header>

                    {(this.state.candidateDeclined ? this.renderDone() : this.renderForm())}
                </div>
            </div>
        );
    }

    changeCheckboxValue() {
        this.setState({checkboxValue: !this.state.checkboxValue});
    }

    renderForm() {
        return (
            <div className="modal-content modal-content-form">
                <div className="description">
                    <p>
                        Decline the candidate only if there is no other possibility. Fees still apply.
                        Please include a messeage for the candidate with a reason for declining.
                    </p>
                </div>
                <div className="form-control-checkbox" onClick={this.changeCheckboxValue.bind(this)}>
                    <input type="checkbox" checked={this.state.checkboxValue}  />
                    <span className="fake-checkbox"></span>
                    <div className="checkbox-description">
                        <h3 className="label-title">Cancellation initiated by professional</h3>
                    </div>
                </div>
                {this.state.checkboxValue ? '' :
                    <div className={"message " + (this.state.messageError ? "has-error" : "")}>
                        <div className="label-title">Message to the candidate</div>
                        <textarea ref="messageBox" rows="6" onChange={this.textChange.bind(this)}
                                  value={this.state.message}
                                  className="post-modal-editor"/>
                        <span className="error-block">Please write a message with an explanation to the candidate</span>
                    </div>
                }

                <div className="buttons">
                    <button className="btn btn-green btn-small" onClick={this.declineCandidate.bind(this)}>Decline</button>
                    <button className="btn-transparent" onClick={this.toggleModal.bind(this)}>Back</button>
                </div>
            </div>
        );
    }

    textChange(e) {
        this.setState({message: e.target.value});
    }

    declineCandidate() {
        const message = _.trim(this.state.message.replace(/<\/?[^>]+(>|$)/g, ""));
        const status = this.state.checkboxValue ? 'cancelled' : 'cancelled by us';
        if (!message && !this.state.checkboxValue) {
            this.setState({messageError: true});
        } else {
            // Need to store candidate name, otherwise candidate will get declined and props will get replaced by new candidate
            // that had nothing to do with the actual decline
            this.setState({messageError: false, candidateDeclined: true, declinedCandidateName: this.props.candidateName});
            this.props.declineCandidate(status, message)
        }
    }

    renderDone() {
        return (
            <div className="modal-content modal-content-sent">
                <div className="sent-msg">
                    <img className="modal-sent-img" src={require('../styles/images/icon_update_sent.svg')} alt="" />
                    <h1>{this.state.declinedCandidateName} has been successfully declined and notified!</h1>
                    <button className="btn btn-bordered btn-small btn-close" onClick={this.toggleModal.bind(this)}>Close</button>
                </div>
            </div>
        );
    }

    modalClick(evt) {
        evt.stopPropagation();
    }

    toggleModal() {
        this.props.toggleModal();
        // without this settimeout the content of modal would change before the modal actually closes
        setTimeout(() => {
            this.setState({
                declinedCandidateName: '',
                candidateDeclined: false,
                checkboxValue: false,
                message: ''
            });
        }, 500);
    }
}

export default DeclineModal;



/** WEBPACK FOOTER **
 ** ./app/src/components/DeclineModal.js
 **/